<template>
    <!--手机信息查重，产品没确认-->
    <div class="background-supplement-no-title-layout">
        <div class="layout-content user-content form">
            <form v-if="isSuccess" class="user-bind">
                <div class="form-list phone-validate">
                    <label>手机号:</label>
                    <el-input type="text" v-model="phoneNumber" placeholder="中国大陆11位手机号" @blur="blurPhoneNumber" @focus="focusInput('phoneVerify')" :maxlength="11"></el-input>
                    <input type="text" style="display: none">
                    <div class="validate" :class="phoneVerify"><i></i></div>
                </div>
                <div class="form-list captchas-validate">
                    <label>图片验证码:</label>
                    <div class="captchas-img">
                        <img :src="captchaImg" alt="验证码"/>
                        <a @click="refreshCaptcha" style="color:#D6CDCB">换一张</a>
                    </div>
                    <el-input type="text" v-model="captchaCode" placeholder="输入图片上的字母" @blur="blurCaptchaCode" @focus="focusInput('captchaCodeVerify')"></el-input>
                    <div class="validate" :class="captchaCodeVerify"><i></i></div>
                </div>
                <div class="form-list mobile-validate">
                    <label>手机验证码:</label>
                    <el-input type="text" v-model="mobileCode" placeholder="输入手机获取的验证码" @blur="blurMobileCode" @focus="focusInput('mobileVerify')"></el-input>
                    <a v-if="!isCaptchaSame" disabled><b></b>获取验证码</a>
                    <template v-else>
                        <a @click="getMobileCode" :class="{'hide': resendFlag}" style="color:#D6CDCB"><b></b>获取验证码</a>
                        <span class="afterTime" :class="{'hide': !resendFlag}">倒计时{{ time }}秒</span>
                    </template>
                    <div class="validate" :class="mobileVerify"><i></i></div>
                </div>
                <div class="form-list" style="margin-top: 10px;height: 20px;line-height: 20px;">
                    <div class="warning-content" :class="warnVerify" v-if="warnMsg">
                        <i></i>{{ warnMsg }}
                    </div>
                </div>
                <div class="form-list" style="margin-top: 0">
                    <el-button v-loading="loading" class="form-btn" @click="handleBind">确认绑定</el-button>
                </div>
            </form>
            <div class="success" v-else>
                <div class="success-notice">
                    <img src="../../../assets/images/common/bind-success.png">
                    已绑定
                </div>
                <p>当前绑定手机号为： {{ communicationInfo.phone }}</p>
                <p>您可以使用该手机号享有手机登录、手机找回等服务</p>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import Vue from 'vue';
export default {
    data() {
        return {
            flag: true, // 防止重复提交
            loading: false,
            phoneNumber: null,
            phoneRegisted: false, // 手机号是否注册过
            phoneVerify: null,
            captchaCode: null,
            captchaCodeVerify: null,
            isCaptchaSame: false, // 图片验证码是否一致，一致时才能发送手机验证码
            captchaId: '', // 图片验证码ID
            captchaImg: '', // 图片验证码地址
            mobileCode: null,
            mobileVerify: null,
            time: 60, // 验证码发送60秒后可重发
            readMe: false,
            warnVerify: null,
            warnMsg: '',
            isSuccess: false // 是否绑定成功
        };
    },
    computed: {
        ...mapState({
            communicationInfo: state => state.user.communicationInfo
        }),
        resendFlag() {
            // 验证码重新发送标识
            return this.time !== 60;
        }
    },
    created() {
        if (!this.communicationInfo.checkBind) {
            this.USER_GET_COMMUNICATION().then(info => {
                if (info.phone) {
                    this.isSuccess = true;
                }
            });
        } else if (this.communicationInfo.phone) {
            this.isSuccess = true;
        }
    },
    beforeMount() {
        this.refreshCaptcha();
    },
    methods: {
        ...mapActions(['USER_GET_CAPTCHA', 'USER_VERIFY_CAPTCHA', 'USER_GET_COMMUNICATION']),
        // 输入框获取焦点移除相关错误提醒
        focusInput(item) {
            this[item] = '';
            if (item === 'phoneVerify') {
                this.phoneRegisted = false;
            }
            if (item === 'captchaCodeVerify') {
                this.isCaptchaSame = false;
            }
            this.warnVerify = '';
            this.warnMsg = '';
        },
        blurPhoneNumber() {
            if (this.phoneNumber) {
                this.checkPhoneNumber();
            }
        },
        blurCaptchaCode() {
            let captchaCode = this.captchaCode;
            let captchaId = this.captchaId;
            let captchaReg = /^\d{4}$/;
            let isCaptcha = captchaReg.test(captchaCode);
            if (isCaptcha && this.flag) {
                let that = this;
                that.captchaCodeVerify = 'checking';
                that.flag = false;
                that
                    .USER_VERIFY_CAPTCHA({ captchaId, inputText: captchaCode })
                    .then(() => {
                        that.isCaptchaSame = true;
                        that.captchaCodeVerify = 'right';
                        that.flag = true;
                    })
                    .catch(() => {
                        that.flag = true;
                        that.captchaCodeVerify = 'error';
                        that.refreshCaptcha();
                    });
            } else {
                if (captchaCode && !isCaptcha) {
                    this.captchaCodeVerify = 'error';
                }
            }
        },
        blurMobileCode() {
            if (this.mobileCode) {
                this.checkMobileCode();
            }
        },
        checkPhoneNumber() {
            let phoneNumber = this.phoneNumber;
            let phoneReg = /^1[3456789][0-9]{9}$/;
            if (phoneReg.test(phoneNumber) && !this.phoneRegisted) {
                this.phoneVerify = 'right';
                return true;
            }
            if (!phoneNumber) {
                this.phoneVerify = 'empty';
                return false;
            } else if (this.phoneRegisted) {
                this.phoneVerify = 'registed';
                return false;
            }
            this.phoneVerify = 'error';
            return false;
        },
        checkCaptchaCode() {
            let captchaCode = this.captchaCode;
            let captchaId = this.captchaId;
            let captchaReg = /^\d{4}$/;
            if (captchaReg.test(captchaCode) && captchaId && this.isCaptchaSame) {
                this.captchaCodeVerify = 'right';
                return true;
            }
            if (!captchaCode) {
                this.captchaCodeVerify = 'empty';
                return false;
            }
            this.captchaCodeVerify = 'error';
            return false;
        },
        checkMobileCode() {
            let mobileCode = this.mobileCode;
            let testReg = /^\d{4}$/;
            if (!mobileCode) {
                this.mobileVerify = 'empty';
                return false;
            } else if (testReg.test(mobileCode)) {
                this.mobileVerify = 'right';
                return true;
            }
            this.mobileVerify = 'error';
            return false;
        },
        // 刷新图片验证码
        refreshCaptcha() {
            if (this.flag) {
                let that = this;
                this.flag = false;
                that
                    .USER_GET_CAPTCHA({ captchaId: this.captchaId })
                    .then(data => {
                        that.captchaId = data.captchaId;
                        that.captchaImg = data.url;
                    })
                    .catch(() => {
                        that.captchaId = '';
                        that.captchaImg = '';
                    })
                    .finally(() => {
                        that.isCaptchaSame = false;
                        that.flag = true;
                    });
            }
        },
        // 手机验证码等待60秒可重发
        waitFor60s() {
            let that = this;
            this.timer = setInterval(() => {
                if (that.time > 0) {
                    that.time -= 1;
                } else {
                    clearInterval(that.timer);
                    that.time = 60;
                }
            }, 1000);
        },
        getMobileCode() {
            if (this.flag) {
                let that = this;
                that.flag = false;
                that.mobileVerify = 'checking';
                setTimeout(() => {
                    let checkPhone = that.checkPhoneNumber();
                    let checkCaptcha = that.checkCaptchaCode();
                    if (checkPhone && checkCaptcha) {
                        Vue.http
                            .post('/v1/user-center/bind-phone-vcodes', {
                                phone: that.phoneNumber
                            })
                            .then(resp => Vue.checkResp(resp))
                            .then(() => {
                                that.mobileVerify = 'right';
                                that.waitFor60s();
                            })
                            .catch(err => {
                                if (err.code === 1008) {
                                    that.phoneVerify = 'registed';
                                }
                                that.warnVerify = 'error';
                                that.warnMsg = err.msg;
                            })
                            .finally(() => {
                                that.flag = true;
                            });
                    } else {
                        that.flag = true;
                        that.mobileVerify = '';
                    }
                }, 500);
            }
        },
        handleBind() {
            // 确认绑定
            if (this.flag) {
                let that = this;
                that.flag = false;
                that.warnVerify = 'checking';
                setTimeout(() => {
                    // 手机验证
                    let checkPhone = that.checkPhoneNumber();
                    let checkMobileCode = that.checkMobileCode();
                    if (checkPhone && checkMobileCode) {
                        this.loading = true;
                        let phone = that.phoneNumber;
                        let vCode = that.mobileCode;

                        Vue.http
                            .post('/v1/user-center/bind-phone', {
                                phone,
                                vCode
                            })
                            .then(resp => Vue.checkResp(resp))
                            .then(() => {
                                that.warnVerify = '';
                                that.USER_GET_COMMUNICATION();
                                // 绑定成功
                                that.isSuccess = true;
                            })
                            .catch(err => {
                                that.warnVerify = 'error';
                                that.warnMsg = err.msg;
                            })
                            .finally(() => {
                                that.flag = true;
                                that.loading = false;
                            });
                    } else {
                        that.warnVerify = '';
                        that.flag = true;
                    }
                }, 500);
            }
        }
    }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .user-bind {
        padding: 70px 55px;
    }

    .bind-phone {
        height: 40px;
        margin-bottom: 16px;

        span {
            width: 83px;
            height: 40px;
            line-height: 40px;
            margin-right: 10px;
            display: inline-block;
            font-size: 14px;
            color: #333;
            letter-spacing: 9px;
        }

        input {
            width: 380px;
            height: 40px;
            line-height: 40px;
            display: inline-block;
            padding-left: 10px;
            border: 1px solid #e7e7e7;
            font-size: 14px;
        }

        input::-webkit-input-placeholder {
            color: #b1b1b1;
        }

        img {
            margin-left: 10px;
            width: 16px;
            height: 16px;
        }
    }

    .captchas-validate {
        height: 40px;
        margin-bottom: 16px;

        span {
            width: 86px;
            height: 40px;
            line-height: 40px;
            margin-right: 10px;
            display: inline-block;
            font-size: 14px;
            color: #333;
            float: left;
        }

        input {
            width: 270px;
            height: 40px;
            line-height: 40px;
            display: inline-block;
            padding-left: 10px;
            border: 1px solid #e7e7e7;
            float: left;
            font-size: 14px;
        }

        input::-webkit-input-placeholder {
            color: #b1b1b1;
        }

        .captchas-img {
            width: 100px;
            height: 40px;
            border: 1px solid #e7e7e7;
            display: inline-block;
            margin-left: 10px;
            position: relative;
            text-align: center;
            line-height: 40px;
            overflow: hidden;

            img {
                width: 100%;
                height: 40px;
            }

            img:hover ~ a {
                transition: opacity, top 1s ease-in-out 0s;
                animation-fill-mode: forwards;
                opacity: 1;
                top: 0;
                color: #fff;
            }

            a {
                width: 100%;
                height: 40px;
                display: block;
                position: absolute;
                top: 40px;
                opacity: 0;
                background: rgba(0, 0, 0, 0.5);
            }

            a:hover {
                color: #fff;
                opacity: 1;
                top: 0;
                z-index: 99;
                cursor: pointer;
            }
        }
    }

    .mobile-validate {
        height: 40px;
        margin-bottom: 16px;

        span {
            width: 86px;
            height: 40px;
            line-height: 40px;
            margin-right: 10px;
            display: inline-block;
            font-size: 14px;
            color: #333;
            float: left;
        }

        input {
            width: 270px;
            height: 40px;
            line-height: 40px;
            display: inline-block;
            padding-left: 10px;
            border: 1px solid #e7e7e7;
            float: left;
            font-size: 14px;
        }

        input::-webkit-input-placeholder {
            color: #b1b1b1;
        }

        a,
        .afterTime {
            width: 100px;
            height: 40px;
            border: 1px solid #e7e7e7;
            display: inline-block;
            margin-left: 10px;
            text-align: center;
            line-height: 40px;
            color: #b1b1b1;
            z-index: 999;
            cursor: pointer;
        }

        .hide {
            display: none;
        }
    }

    .go-bind {
        width: 382px;
        height: 40px;
        padding: 0;
        line-height: 40px;
        margin-left: 94px;
        font-size: 16px;
        border-radius: 2px;
    }

    .success {
        width: 100%;
        min-height: 555px;
        background-color: #fff;
        padding-top: 188px;

        .success-notice {
            height: 50px;
            width: 300px;
            margin: 0 auto;
            margin-bottom: 20px;
            line-height: 50px;
            text-align: center;
            font-size: 18px;
            color: #50c059;

            img {
                width: 50px;
                height: 50px;
                vertical-align: middle;
                margin-right: 20px;
            }
        }

        p {
            width: 330px;
            margin: 0 auto;
            text-align: center;
            height: 20px;
            line-height: 20px;
            margin-bottom: 5px;
            font-size: 14px;
            color: #4d4d4d;
        }
    }

    .mobile-validate a {
        background-color: #fff !important;
        color: #d6cdcb;
    }
</style>



// WEBPACK FOOTER //
// src/views/index/components/UserBind.vue